import { createGetDataReducer } from "./CommonReducer";
import { NOTIFICATIONLIST ,NOTIFICATIONADD } from "../../Constants/NotificationConstants";

export const NotificationReducer = createGetDataReducer( NOTIFICATIONLIST );
export const NotificationAddReducer = createGetDataReducer( NOTIFICATIONADD );
